import React from "react";
import { Star, ArrowSquareOut } from "@phosphor-icons/react";

export const HOMESTARS_URL =
  "https://www.homestars.com/profile/2970106-troya-minibins";

/**
 * HomeStarsBadge
 * Displays the verified HomeStars trust signal with real rating + review count.
 *
 * Props:
 *  - rating: number (e.g. 5.0)
 *  - count: number (e.g. 7)
 *  - variant: "light" | "dark"
 *  - compact: boolean
 */
export default function HomeStarsBadge({
  rating = 5.0,
  count = 7,
  variant = "light",
  compact = false,
}) {
  const onDark = variant === "dark";
  return (
    <a
      data-testid="homestars-badge"
      href={HOMESTARS_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={`group inline-flex items-center gap-4 border-2 ${
        onDark
          ? "border-sky-400/40 bg-slate-800/60 hover:bg-slate-800"
          : "border-slate-900 bg-white hover:bg-slate-50"
      } px-4 py-3 transition-colors`}
      aria-label={`Read our ${count} verified ${rating.toFixed(1)}-star HomeStars reviews`}
    >
      {/* HomeStars green mark */}
      <div
        className="relative flex items-center justify-center h-12 w-12 bg-[#16a34a] shrink-0"
        aria-hidden
      >
        <Star size={26} weight="fill" className="text-white" />
        <span className="absolute -bottom-1 left-1/2 -translate-x-1/2 text-[8px] font-extrabold tracking-[0.18em] uppercase text-white bg-emerald-700 px-1.5 py-0.5">
          HS
        </span>
      </div>
      <div className="leading-tight">
        <div
          className={`text-[10px] font-extrabold tracking-[0.22em] uppercase ${
            onDark ? "text-emerald-300" : "text-emerald-700"
          }`}
        >
          Verified on HomeStars
        </div>
        <div className="flex items-center gap-2 mt-1">
          <div className="flex gap-0.5">
            {Array.from({ length: 5 }).map((_, i) => (
              <Star key={i} size={14} weight="fill" className="text-amber-500" />
            ))}
          </div>
          <span
            className={`font-display font-black text-base ${
              onDark ? "text-white" : "text-slate-900"
            }`}
          >
            {rating.toFixed(1)}
          </span>
          <span
            className={`text-xs font-bold ${
              onDark ? "text-slate-300" : "text-slate-600"
            }`}
          >
            · {count} reviews
          </span>
          {!compact && (
            <ArrowSquareOut
              size={14}
              weight="bold"
              className={`${
                onDark ? "text-slate-300" : "text-slate-500"
              } group-hover:translate-x-0.5 transition-transform`}
            />
          )}
        </div>
      </div>
    </a>
  );
}
